module.exports = __webpack_public_path__ + "img/leiterinnen_evelyn-dober.2dd9381e.png";